// extracted by mini-css-extract-plugin
export default {"MessageLoader":"MessageLoader_MessageLoader__2FQxl","BTWBounce":"MessageLoader_BTWBounce__9R2bu","b1":"MessageLoader_b1__FIGUJ","b2":"MessageLoader_b2__AhpF8"};